module.exports = __webpack_public_path__ + "static/media/reports_active_new.68abf7a9.svg";